import * as React from 'react';

export const REGISTER_PAGE_TEXTS = {
  WELCOME: 'Добро пожаловать!',
  PICK_PASSWORD: <>Для регистрации в&nbsp;нашем сервисе придумайте пароль.</>,
  PASSWORD_REQUIREMENTS: (
    <>
      Пароль должен содержать не&nbsp;менее 8&nbsp;символов и&nbsp;включать
      в&nbsp;себя как минимум одну заглавную букву и&nbsp;число.
    </>
  ),
  INPUT_PASSWORD: 'Введите пароль',
  PLEASE_INPUT_PASSWORD: 'Пожалуйста, введите пароль!',
  REPEAT_PASSWORD: 'Повторите пароль',
};
